import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * A custom element that displays the carat/colour/clarity/metal spec line
 * on the product page. The metal portion depends on the selected variant,
 * so this listens for variant updates and copies the freshly server-rendered
 * spec line (Shopify already fetches it on every variant change) rather
 * than recomputing anything client-side.
 *
 * @extends {Component}
 */
class SpecLineVerrieComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateSpecLine);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecLine);
  }

  updateSpecLine = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpecLine = event.detail.data.html?.querySelector('.spec-line-verrie');
    if (newSpecLine) {
      this.innerHTML = newSpecLine.innerHTML;
    }
  };
}

if (!customElements.get('spec-line-verrie-component')) {
  customElements.define('spec-line-verrie-component', SpecLineVerrieComponent);
}
